import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const mutationDeleteAllCustomerCarts = {
  async deleteAllCustomerCarts(parent, args, context, info) {
    let { customerId, customerKey } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.DELETE,
    })

    const commerceApi = CommerceService.api()

    if (typeof customerId !== "string" && typeof customerKey !== "string") return null

    const isKey = typeof customerKey === "string"

    let customer = {}

    // get customer
    if (isKey) customer = (await commerceApi.customers().withKey({ key: customerKey }).get().execute())?.body
    else customer = (await commerceApi.customers().withId({ ID: customerId }).get().execute())?.body

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    // get all customer carts
    let customerCarts =
      (
        await commerceApi
          .carts()
          .get({ queryArgs: { where: `customerId="${customer.id}"` } })
          .execute()
      ).body?.results || []

    const allPromises = []
    for (let cart of customerCarts) {
      const promise = commerceApi
        .carts()
        .withId({ ID: cart.id })
        .delete({ queryArgs: { version: cart.version } })
        .execute()

      allPromises.push(promise)
    }

    await Promise.all(allPromises)

    return customerCarts
  },
}
